<template>
  <v-text-field
    v-if="!readonly"
    ref="textField"
    :class="customData.class"
    v-bind="{...$props, ...customData.props, ...customData.attrs}"
    v-on="$listeners"
  >
    <template #prepend>
      <slot name="prepend" />
    </template>

    <template #prepend-inner>
      <slot name="prepend-inner" />
    </template>

    <template #append>
      <slot name="append" />
    </template>

    <template #append-outer>
      <slot name="append-outer" />
    </template>
  </v-text-field>
  <w-read-only-text-field
    v-else
    v-bind="$props"
    v-on="$listeners"
  />
</template>

<script>
import { VTextField } from "vuetify/lib";
import isRequired from '@/mixins/component/is-required-mixin';
import pendingAble from '@/mixins/component/pending-able-mixin';
import { getRequiredLabelProp } from '@/components/global_components/forms/utils/required-label-util';

export default {
  name: "WorkTextField",
  mixins: [isRequired, pendingAble],
  props: {
    ...VTextField.options.props,
    autocomplete: { type: String, required: false },
  },
  computed: {
    customData() {
      return {
        attrs: { autocomplete: this.autocomplete },
        class: [
          'w-text-field--input',
          { 'w-text-field--input--has-label': this.label },
          this.$attrs.class
        ],
        props: {
          outlined: true,
          dense: true,
          hideDetails: 'auto',
          clearIcon: '$wClose',
          ...getRequiredLabelProp(this.$props)
        },
      };
    }
  },
  methods: {
    focus() {
      this.$refs.textField?.focus();
    }
  }
};
</script>

<style lang="scss">

.w-text-field--input > .v-input__control > .v-input__slot {
  background-color: $input-bg-color;
}

.w-text-field--input--has-label {
  margin-top: 0.25rem !important;

  & > .v-input__control {
    .v-input__slot > * {
        font-size: 1rem;
        }
    }
    .v-input__prepend-inner,
    .v-input__append-inner {
      margin: auto;
    }
}
</style>